//
// Plan Directive Dialog.
//
// https://www.pluralsight.com/guides/working-with-bootstraps-modals-react
//
import 'bootstrap/dist/js/bootstrap.min.js';
import Modal from "react-bootstrap/Modal";
import { useState, useEffect } from 'react';
import gEventRouter from "../script/event_router.js";
import gUtilities from '../script/utilities';
import gSession from '../script/session.js';

// TODO: Retrieve from DB(?)
const kDefaultBoronFmExpression = "-1.602e-10 5010 h -4"
const kDefaultGammaFmExpression = "1.602e-10"
const kDefaultHydrogenFmExpression = "-1.602e-10 1001 h -4"
const kDefaultNitrogenFmExpression = "-1.602e-10 7014 h -4"

const DirectiveDialog = () => {
    const [job, setJob] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [reload, setReload] = useState(true);
    const [directives, setDirectives] = useState(null);

    // job is the full job from the PlanDialog
    const showModal = (job) => {
        setJob(job);
        setReload(true);
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    function fillDirectives() {
        let widget;
        let toggle;
        let modified = JSON.parse(JSON.stringify(directives));

        toggle = getWidget("w_VoidCardSwitch");
        if (toggle) {
            modified.VOID = {
                enabled: toggle.checked,
                value: toggle.checked
            };
        }

        toggle = getWidget("w_FluxCardSwitch");
        if (toggle) {
            modified.FLUX = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_UncertaintySwitch");
        if (widget) {
            modified.UNCERTAINTY = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_ProtonParticleSwitch");
        if (toggle) {
            modified.PROTON = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_AirSwitch");
        if (toggle) {
            modified.AIR = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_MeshSwitch");
        if (toggle) {
            modified.MESH = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_NitrogenN14Switch");
        if (toggle) {
            modified.NITROGEN_N14_TALLY = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_HydrogenH1TallySwitch");
        if (toggle) {
            modified.HYDROGEN_H1_TALLY = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_StatepointRecordSwitch");
        if (toggle) {
            modified.STATEPOINT_RECORD = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_XrbeSwitch");
        if (toggle) {
            modified.XRBE = {
                value: toggle.checked,
                enabled: toggle.checked
            };
        }

        toggle = getWidget("w_DiskSwitch");
        if (toggle) {
            widget = getWidget("w_DiskRadiusTextbox");
            modified.DISK = {
                enabled: toggle.checked,
                value: toFloat("Disk Radius", widget.value)
            };
        }

        toggle = getWidget("w_EnergySwitch");
        if (toggle) {
            widget = getWidget("w_EnergyTextbox");
            modified.ENERGY = {
                enabled: toggle.checked,
                value: toFloat("Particle Energy", widget.value)
            };
        }

        toggle = getWidget("w_TargetBCRSwitch");
        if (toggle) {
            widget = getWidget("w_TargetBCRTextbox");
            modified.TARGET_BCR = {
                enabled: toggle.checked,
                value: toFloat("BCR", widget.value)
            };
        }

        toggle = getWidget("w_HwdfSwitch");
        if (toggle) {
            widget = getWidget("w_HwdfTextbox");
            modified.HWDF = {
                enabled: toggle.checked,
                value: toFloat("HWDF", widget.value)
            };
        }

        toggle = getWidget("w_TallyMultiplierSwitch");
        if (toggle) {
            widget = getWidget("w_TallyMultiplierTextbox");
            modified.TALLY_MULTIPLIER = {
                enabled: toggle.checked,
                value: toFloat("Tally Multiplier", widget.value)
            };
        }

        toggle = getWidget("w_CountSwitch");
        if (toggle) {
            widget = getWidget("w_CountTextbox");
            modified.COUNT = {
                enabled: toggle.checked,
                value: toFloat("Particle Count", widget.value)
            };
        }

        toggle = getWidget("w_SeedSwitch");
        if (toggle) {
            widget = getWidget("w_SeedTextbox");
            modified.SEED = {
                enabled: toggle.checked,
                value: toFloat("Random Seed", widget.value)
            };
        }

        toggle = getWidget("w_NodeCountSwitch");
        if (toggle) {
            widget = getWidget("w_NodeCountTextbox");
            modified.NODE_COUNT = {
                enabled: toggle.checked,
                value: toFloat("Node Count", widget.value)
            };
        }

        toggle = getWidget("w_UsernameSwitch");
        if (toggle) {
            widget = getWidget("w_UsernameTextbox");
            modified.USER = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_NoteSwitch");
        if (toggle) {
            widget = getWidget("w_NoteTextbox");
            modified.NOTE = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_TagSwitch");
        if (toggle) {
            widget = getWidget("w_TagTextbox");
            modified.TAG = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_UsernameSwitch");
        if (toggle) {
            widget = getWidget("w_UsernameTextbox");
            modified.USER = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_BoronFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_BoronFmExpressionTextbox");
            modified.BORON_FM_EXPRESSION = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_GammaFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_GammaFmExpressionTextbox");
            modified.GAMMA_FM_EXPRESSION = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_HydrogenFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_HydrogenFmExpressionTextbox");
            modified.HYDROGEN_FM_EXPRESSION = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        toggle = getWidget("w_NitrogenFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_NitrogenFmExpressionTextbox");
            modified.NITROGEN_FM_EXPRESSION = {
                enabled: toggle.checked,
                value: widget.value
            };
        }

        return modified;
    }

    const setFields = () => {
        let toggle;
        let widget;

        if (!directives) {
            return;
        }

        toggle = getWidget("w_VoidCardSwitch");
        if (toggle) {
            if (directives.VOID && directives.VOID.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_FluxCardSwitch");
        if (toggle) {
            if (directives.FLUX && directives.FLUX.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_UncertaintySwitch");
        if (toggle) {
            if (directives.UNCERTAINTY && directives.UNCERTAINTY.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_ProtonParticleSwitch");
        if (toggle) {
            if (directives.PROTON && directives.PROTON.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_AirSwitch");
        if (toggle) {
            if (directives.AIR && directives.AIR.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_MeshSwitch");
        if (toggle) {
            if (directives.MESH && directives.MESH.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_NitrogenN14Switch");
        if (toggle) {
            if (directives.NITROGEN_N14_TALLY && directives.NITROGEN_N14_TALLY.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_HydrogenH1TallySwitch");
        if (toggle) {
            if (directives.HYDROGEN_H1_TALLY && directives.HYDROGEN_H1_TALLY.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_StatepointRecordSwitch");
        if (toggle) {
            if (directives.STATEPOINT_RECORD && directives.STATEPOINT_RECORD.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_XrbeSwitch");
        if (toggle) {
            if (directives.XRBE && directives.XRBE.enabled) {
                toggle.checked = true;
            } else {
                toggle.checked = false;
            }
        }

        toggle = getWidget("w_DiskSwitch");
        if (toggle) {
            widget = getWidget("w_DiskRadiusTextbox");
            if (directives.DISK && directives.DISK.enabled) {
                toggle.checked = true;
                widget.value = directives.DISK.value;
            } else {
                toggle.checked = false;
                widget.value = "0.0";
            }
        }

        toggle = getWidget("w_EnergySwitch");
        if (toggle) {
            widget = getWidget("w_EnergyTextbox");
            if (directives.ENERGY && directives.ENERGY.enabled) {
                toggle.checked = true;
                widget.value = directives.ENERGY.value;
            } else {
                toggle.checked = false;
                widget.value = "0.08";
            }
        }

        toggle = getWidget("w_TargetBCRSwitch");
        if (toggle) {
            widget = getWidget("w_TargetBCRTextbox");
            if (directives.TARGET_BCR && directives.TARGET_BCR.enabled) {
                toggle.checked = true;
                widget.value = directives.TARGET_BCR.value;
            } else {
                toggle.checked = false;
                widget.value = "0.0";
            }
        }

        toggle = getWidget("w_HwdfSwitch");
        if (toggle) {
            widget = getWidget("w_HwdfTextbox");
            if (directives.HWDF && directives.HWDF.enabled) {
                toggle.checked = true;
                widget.value = directives.HWDF.value;
            } else {
                toggle.checked = false;
                widget.value = "0.0";
            }
        }

        toggle = getWidget("w_TallyMultiplierSwitch");
        if (toggle) {
            widget = getWidget("w_TallyMultiplierTextbox");
            if (directives.TALLY_MULTIPLIER && directives.TALLY_MULTIPLIER.enabled) {
                toggle.checked = true;
                widget.value = directives.TALLY_MULTIPLIER.value;
            } else {
                toggle.checked = false;
                widget.value = "0.0";
            }
        }

        toggle = getWidget("w_CountSwitch");
        if (toggle) {
            widget = getWidget("w_CountTextbox");
            if (directives.COUNT && directives.COUNT.enabled) {
                toggle.checked = true;
                widget.value = directives.COUNT.value;
            } else {
                toggle.checked = false;
                widget.value = "1e6";
            }
        }

        toggle = getWidget("w_SeedSwitch");
        if (toggle) {
            widget = getWidget("w_SeedTextbox");
            if (directives.SEED && directives.SEED.enabled) {
                toggle.checked = true;
                widget.value = directives.SEED.value;
            } else {
                toggle.checked = false;
                widget.value = "7397815529";
            }
        }

        toggle = getWidget("w_NodeCountSwitch");
        if (toggle) {
            widget = getWidget("w_NodeCountTextbox");
            if (directives.NODE_COUNT && directives.NODE_COUNT.enabled) {
                toggle.checked = true;
                widget.value = directives.NODE_COUNT.value;
            } else {
                toggle.checked = false;
                widget.value = "4";
            }
        }

        toggle = getWidget("w_UsernameSwitch");
        if (toggle) {
            widget = getWidget("w_UsernameTextbox");
            if (directives.USER && directives.USER.enabled) {
                toggle.checked = true;
                widget.value = directives.USER.value;
            } else {
                toggle.checked = false;
                widget.value = "username";
            }
        }

        toggle = getWidget("w_NoteSwitch");
        if (toggle) {
            widget = getWidget("w_NoteTextbox");
            if (directives.NOTE && directives.NOTE.enabled) {
                toggle.checked = true;
                widget.value = directives.NOTE.value;
            } else {
                toggle.checked = false;
                widget.value = "comment";
            }
        }

        toggle = getWidget("w_TagSwitch");
        if (toggle) {
            widget = getWidget("w_TagTextbox");
            if (directives.TAG && directives.TAG.enabled) {
                toggle.checked = true;
                widget.value = directives.TAG.value;
            } else {
                toggle.checked = false;
                widget.value = "search.filter";
            }
        }

        toggle = getWidget("w_BoronFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_BoronFmExpressionTextbox");
            if (directives.BORON_FM_EXPRESSION && directives.BORON_FM_EXPRESSION.enabled) {
                toggle.checked = true;
                widget.value = directives.BORON_FM_EXPRESSION.value;
            } else {
                toggle.checked = false;
                widget.value = kDefaultBoronFmExpression;
            }
        }

        toggle = getWidget("w_GammaFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_GammaFmExpressionTextbox");
            if (directives.GAMMA_FM_EXPRESSION && directives.GAMMA_FM_EXPRESSION.enabled) {
                toggle.checked = true;
                widget.value = directives.GAMMA_FM_EXPRESSION.value;
            } else {
                toggle.checked = false;
                widget.value = kDefaultGammaFmExpression;
            }
        }

        toggle = getWidget("w_HydrogenFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_HydrogenFmExpressionTextbox");
            if (directives.HYDROGEN_FM_EXPRESSION && directives.HYDROGEN_FM_EXPRESSION.enabled) {
                toggle.checked = true;
                widget.value = directives.HYDROGEN_FM_EXPRESSION.value;
            } else {
                toggle.checked = false;
                widget.value = kDefaultHydrogenFmExpression;
            }
        }

        toggle = getWidget("w_NitrogenFmExpressionSwitch");
        if (toggle) {
            widget = getWidget("w_NitrogenFmExpressionTextbox");
            if (directives.NITROGEN_FM_EXPRESSION && directives.NITROGEN_FM_EXPRESSION.enabled) {
                toggle.checked = true;
                widget.value = directives.NITROGEN_FM_EXPRESSION.value;
            } else {
                toggle.checked = false;
                widget.value = kDefaultNitrogenFmExpression;
            }
        }
    }

    function toFloat(name, text) {
        let value = parseFloat(text);
        if (isNaN(value)) {
            throw new Error(`Invalid float value ${text} for ${name}`);
        }

        return value;
    }

    async function onApply() {
        let modified;

        try {
            modified = fillDirectives();
        } catch (ex) {
            gUtilities.showError("Read Values", ex.toString());
            return;
        }

        modified.plan_name = job.plan.plan_name;
        modified.patient_id = job.plan.patient_id;

        let request = {
            command: "job.directives_ready",
            job_id: job.job_id,
            directives: modified
        };

        let response = await gSession.exchange(request);
        if (response.isError) {
            gUtilities.showError("Update Directives", response.message);
        } else {
            hideModal();
        }

        setReload(true);
    };

    gEventRouter.register("DirectiveDialog.showModal", showModal);

    async function fetchDirectives() {
        let request = {
            collection: "dcs_directives",
            service: "db.query",
            many: false,
            query: {
                plan_name: job.plan.plan_name,
                patient_id: job.plan.patient_id
            }
        };

        let response = await gSession.exchange(request);

        console.log(response);
        if (response.isError) {
            gUtilities.showError("Fetch Directives", response.message);
        } else {
            setDirectives(response);
        }

        setReload(false);
    }

    function getWidget(id) {
        let widget = document.querySelector("#" + id);

        return widget;
    }

    useEffect(async () => {
        try {
            if (job && reload) {
                await fetchDirectives();
                setFields();
            }
        } catch (ex) {
            gUtilities.showError("Update", ex.toString());
        }
    }, [job, reload, directives]);

    return (
        <div>
            <Modal show={isOpen}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Plan Directives</h5>
                    </div>
                    <div className="modal-body">
                        <ul class="list-group">
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_VoidCardSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_VoidCardSwitch">VOID card</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">No Interactions</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_FluxCardSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_FluxCardSwitch">FLUX</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">Uncertainty,Neutron(x3),Photon</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_UncertaintySwitch"></input>
                                    <label className="form-check-label" htmlFor="w_UncertaintySwitch">Uncertainty</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">Uncertainty Tallies</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_ProtonParticleSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_ProtonParticleSwitch">Protons</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">No Neutrons</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_AirSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_AirSwitch">Air</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">Interactions Outside Anatomy</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_MeshSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_MeshSwitch">Mesh</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">Mesh Tally</span>
                            </li>
                            {isOpen && job.simulator_name === "openmc" &&
                                <>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_HydrogenH1TallySwitch"></input>
                                            <label className="form-check-label" htmlFor="w_HydrogenH1TallySwitch">Hydrogen Tally</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">H1 Only</span>
                                    </li>

                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_NitrogenN14Switch"></input>
                                            <label className="form-check-label" htmlFor="w_NitrogenN14Switch">Nitrogen Tally</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">N14 Only (n,p)</span>
                                    </li>

                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_StatepointRecordSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_StatepointRecordSwitch">Statepoint Record</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">Tally CSV File</span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_NodeCountSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_NodeCountSwitch">Compute Node Count</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="1e6" id="w_NodeCountTextbox"></input>
                                        </span>
                                    </li>
                                </>
                            }
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_XrbeSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_XrbeSwitch">XRBE</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">Override RBE Values</span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_DiskSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_DiskSwitch">Disk Radius (cm)</label>

                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="cm" id="w_DiskRadiusTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_EnergySwitch"></input>
                                    <label className="form-check-label" htmlFor="w_EnergySwitch">Particle Energy (Mev)</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="MeV" id="w_EnergyTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_CountSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_CountSwitch">Particle Count</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="1e6" id="w_CountTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_SeedSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_SeedSwitch">Random Seed</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="7397815529" id="w_SeedTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_TargetBCRSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_TargetBCRSwitch">Target BCR</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="MeV" id="w_TargetBCRTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_UsernameSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_UsernameSwitch">Username</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="username" id="w_UsernameTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_NoteSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_NoteSwitch">Note</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="comment" id="w_NoteTextbox"></input>
                                </span>
                            </li>
                            <li class="list-group-item d-flex justify-content-between align-items-center">
                                <span className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" id="w_TagSwitch"></input>
                                    <label className="form-check-label" htmlFor="w_TagSwitch">Tag</label>
                                </span>
                                <span class="badge bg-primary rounded-pill">
                                    <input type="text" className="form-text-input form-text-input-sm" placeholder="search.filter" id="w_TagTextbox"></input>
                                </span>
                            </li>
                            {isOpen && job.simulator_name === "mcnp" &&
                                <>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_TallyMultiplierSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_TallyMultiplierSwitch">Tally Multiplier</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="1.0" id="w_TallyMultiplierTextbox"></input>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_HwdfSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_HwdfSwitch">Heavy Water Displacement Factor</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="0.0" id="w_HwdfTextbox"></input>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_BoronFmExpressionSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_BoronFmExpressionSwitch">Boron FM Expression</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="" id="w_BoronFmExpressionTextbox"></input>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_GammaFmExpressionSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_GammaFmExpressionSwitch">Gamma FM Expression</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="" id="w_GammaFmExpressionTextbox"></input>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_HydrogenFmExpressionSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_HydrogenFmExpressionSwitch">Hydrogen FM Expression</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="" id="w_HydrogenFmExpressionTextbox"></input>
                                        </span>
                                    </li>
                                    <li class="list-group-item d-flex justify-content-between align-items-center">
                                        <span className="form-check form-switch">
                                            <input className="form-check-input" type="checkbox" id="w_NitrogenFmExpressionSwitch"></input>
                                            <label className="form-check-label" htmlFor="w_NitrogenFmExpressionSwitch">Nitrogen FM Expression</label>
                                        </span>
                                        <span class="badge bg-primary rounded-pill">
                                            <input type="text" className="form-text-input form-text-input-sm" placeholder="" id="w_NitrogenFmExpressionTextbox"></input>
                                        </span>
                                    </li>
                                </>
                            }
                        </ul>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={hideModal}>Close</button>
                        <button type="button" className="btn btn-primary" onClick={onApply}>Apply</button>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default DirectiveDialog;
